<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="pageiii"></a>DOGS</h1>
<h1 class="title1">WHO SERVE</h1>
<h2 class="subtitle">INCREDIBLE STORIES OF OUR CANINE MILITARY HEROES</h2>
<h2 class="author">LISA ROGAK</h2>
<p class="img"><span class="small">THOMAS DUNNE BOOKS</span><br/><br/><span><img alt="" src="OEBPS/images/logo.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?2caeacc4